import {
  getAll,
  getPage,
  getDetail,
  getMyUserGroupAll,
  getMyUserGroupPage,
  getTeamReport,
  getReport,
  addToRemark,
  renewalPayCallback,
  renewalPayOrder,
} from '@/api/renewalpayorderserv'

export default {
  state: {
    state_RenewalPayOrder_GetAllResult: null,
    state_RenewalPayOrder_GetPageResult: null,
    state_RenewalPayOrder_GetDetailResult: null,
    state_RenewalPayOrder_GetMyUserGroupAllResult: null,
    state_RenewalPayOrder_GetMyUserGroupPageResult: null,
    state_RenewalPayOrder_GetTeamReportResult: null,
    state_RenewalPayOrder_GetReportResult: null,
    state_RenewalPayOrder_AddToRemarkResult: null,
    state_RenewalPayOrder_RenewalPayCallbackResult: null,
    state_RenewalPayOrder_RenewalPayOrderResult: null,
  },
  mutations: {
    SET_RENEWALPAYORDER_GETALL_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_GetAllResult = rst;
    },
    SET_RENEWALPAYORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_GetPageResult = rst;
    },
    SET_RENEWALPAYORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_GetDetailResult = rst;
    },
    SET_RENEWALPAYORDER_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_GetMyUserGroupAllResult = rst;
    },
    SET_RENEWALPAYORDER_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_GetMyUserGroupPageResult = rst;
    },
    SET_RENEWALPAYORDER_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_GetTeamReportResult = rst;
    },
    SET_RENEWALPAYORDER_GETREPORT_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_GetReportResult = rst;
    },
    SET_RENEWALPAYORDER_ADDTOREMARK_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_AddToRemarkResult = rst;
    },
    SET_RENEWALPAYORDER_RENEWALPAYCALLBACK_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_RenewalPayCallbackResult = rst;
    },
    SET_RENEWALPAYORDER_RENEWALPAYORDER_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_RenewalPayOrderResult = rst;
    },
  },
  actions: {
    RenewalPayOrderServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_GetMyUserGroupAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_GETMYUSERGROUPALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_GETMYUSERGROUPALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_GetMyUserGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_GETMYUSERGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_GETMYUSERGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_GetTeamReport({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_GETTEAMREPORT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_GETTEAMREPORT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_GetReport({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getReport(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_GETREPORT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_GETREPORT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_AddToRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addToRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_ADDTOREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_ADDTOREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_RenewalPayCallback({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        renewalPayCallback(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_RENEWALPAYCALLBACK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_RENEWALPAYCALLBACK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_RenewalPayOrder({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        renewalPayOrder(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_RENEWALPAYORDER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_RENEWALPAYORDER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_RenewalPayOrder_GetAllResult: state => {
      return state.state_RenewalPayOrder_GetAllResult;
    },
    get_RenewalPayOrder_GetPageResult: state => {
      return state.state_RenewalPayOrder_GetPageResult;
    },
    get_RenewalPayOrder_GetDetailResult: state => {
      return state.state_RenewalPayOrder_GetDetailResult;
    },
    get_RenewalPayOrder_GetMyUserGroupAllResult: state => {
      return state.state_RenewalPayOrder_GetMyUserGroupAllResult;
    },
    get_RenewalPayOrder_GetMyUserGroupPageResult: state => {
      return state.state_RenewalPayOrder_GetMyUserGroupPageResult;
    },
    get_RenewalPayOrder_GetTeamReportResult: state => {
      return state.state_RenewalPayOrder_GetTeamReportResult;
    },
    get_RenewalPayOrder_GetReportResult: state => {
      return state.state_RenewalPayOrder_GetReportResult;
    },
    get_RenewalPayOrder_AddToRemarkResult: state => {
      return state.state_RenewalPayOrder_AddToRemarkResult;
    },
    get_RenewalPayOrder_RenewalPayCallbackResult: state => {
      return state.state_RenewalPayOrder_RenewalPayCallbackResult;
    },
    get_RenewalPayOrder_RenewalPayOrderResult: state => {
      return state.state_RenewalPayOrder_RenewalPayOrderResult;
    },
  }
}